package br.com.vvrefeicoes.portal.domain.model

data class PurchasesExtraReason(
    val id: String,
    val name: String,
    val active: Boolean,
)

data class PurchasesExtraOrder(
    val id: String,
    val orderDate: String,
    val deliveryDate: String?,
    val quantity: Int?,
    val description: String,
    val sourceUnitLabel: String?,
    val unitId: String?,
    val unitName: String?,
    val sortOrder: Int,
    val organogramaUnidadeId: String? = null,
    val reasonId: String? = null,
    val reasonName: String? = null,
    val reasonActive: Boolean = false,
)

data class PurchasesExtraDirectorateMonth(
    val year: Int,
    val month: Int,
    val orderCount: Long,
)

data class PurchasesExtraDirectorate(
    val name: String?,
    val orderCount: Long,
    val months: List<PurchasesExtraDirectorateMonth>,
    val units: List<PurchasesExtraDirectorateUnit> = emptyList(),
)

data class PurchasesExtraDirectorateUnit(
    val name: String,
    val orderCount: Long,
    val months: List<PurchasesExtraDirectorateMonth> = emptyList(),
)

data class PurchasesExtraReasonCount(
    val id: String?,
    val name: String,
    val active: Boolean,
    val orderCount: Long,
)

data class PurchasesExtraAnalytics(
    val months: List<MonthPeriod> = emptyList(),
    val directorates: List<PurchasesExtraDirectorate> = emptyList(),
    val reasons: List<PurchasesExtraReasonCount> = emptyList(),
)

data class PurchasesExtraUnit(
    val id: String,
    val name: String,
    val director: String?,
    val manager: String?,
    val organogramaUnidadeId: String? = null,
)

data class PurchasesExtraUnitSuggestion(
    val label: String,
    val unitId: String?,
    val status: String,
)

data class PurchasesExtraImportOrder(
    val orderDate: String,
    val deliveryDate: String?,
    val quantity: Int?,
    val description: String,
    val sourceUnitLabel: String?,
)

data class PurchasesExtraImportMapping(
    val label: String,
    val unitId: String?,
)

data class PurchasesExtraImportPreview(
    val year: Int,
    val month: Int,
    val orderCount: Int,
    val existingCount: Int,
    val unitCount: Int,
    val willReplace: Boolean,
)

data class PurchasesExtraImportResult(
    val year: Int,
    val month: Int,
    val ordersInserted: Int,
    val existingReplaced: Int,
    val mappingsSaved: Int,
    val unitCount: Int,
)

data class PurchasesExtraSummary(
    val orderCount: Long,
    val totalItems: Long,
)
